import * as Yup from "yup";

export const validString = Yup.string();

export const alphaNumeric = Yup.string().matches(/^[a-zA-Z0-9]+$/i);

export const date = Yup.string().matches(
  /\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z)/
);

export const time = Yup.string().matches(/^([0-1]?[0-9]|2[0-4]):([0-5][0-9])(:[0-5][0-9])?$/);


export const fullName = Yup.string()
    .min(3)
    .max(100);

export const validName = Yup.string()
  .matches(/^[\p{L} ,.'-]+$/u)
  .min(2)
  .max(100);

export const title = Yup.mixed().oneOf([
  "MR",
  "MRS",
  "MS",
  "DATO",
  "DATUK",
  "DATUK SERI",
  "DATIN",
  "DATIN SERI",
  "DR",
  "PROF",
  "ASSOC PROF",
]);

export const gender = Yup.mixed().oneOf(["MALE", "FEMALE"]);

export const identificationType = Yup.mixed().oneOf(["PASSPORT", "NRIC"]);

export const passport = Yup.string()
  .matches(/^[a-zA-Z0-9]+$/)
  .min(5);

export const percent = Yup.string() // dhsn
  .matches(/(^100(\.0{1,2})?$)|(^([1-9]([0-9])?|0)(\.[0-9]{1,2})?$)/gm);

export const nric = Yup.string().matches(
  /^((([[0-9]{2})(0[1-9]|1[0-2])(0[1-9]|[12][0-9]|3[01]))([0-9]{2})([0-9]{4}){1})$/i
);

export const identificationNumber = Yup.string()
  .when("identificationType", { is: "PASSPORT", then: passport })
  .when("identificationType", { is: "NRIC", then: nric });

export const passportIssueDate = Yup.mixed().when("identificationType", {
  is: "PASSPORT",
  then: Yup.string().required(),
  otherwise: Yup.string().optional(),
});

export const passportExpiryDate = Yup.mixed().when("identificationType", {
  is: "PASSPORT",
  then: Yup.string().required(),
  otherwise: Yup.string().optional(),
});

export const passportPlaceOfIssue = Yup.mixed().when("identificationType", {
  is: "PASSPORT",
  then: Yup.string().max(50).required(),
  otherwise: Yup.string().max(50).optional(),
});

// Must contain 8 characters, (1) uppercase, (1) lowercase, (1) number and (1) special case character
export const password = Yup.string().matches(
  /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/
);

export const phoneType = Yup.mixed().oneOf(["FAX", "HOME", "MOBILE", "OFFICE"]);

export const dialCode = Yup.string()
  .matches(/^[0-9]+$/)
  .min(1)
  .max(7);

export const phoneNumber = Yup.string()
  .matches(/^[0-9]+$/)
  .min(4)
  .max(12);

export const fullContactNumber = Yup.string()
  .matches(/^[0-9]+$/)
  .min(5)
  .max(19);

export const fullContact = Yup.object({
  dialCode: dialCode.required(),
  number: phoneNumber.optional(),
});

export const email = Yup.string().email();

export const addressType = Yup.mixed().oneOf([
  "HOME",
  "OFFICE",
  "WAREHOUSE",
  "RESIDENTIAL",
  "COMMERCIAL",
]);

export const addressUnit = Yup.string().max(20);

export const addressBlock = Yup.string().max(20);

export const addressLevel = Yup.string().max(20);

export const addressLine = Yup.string().max(100);

export const city = Yup.string().max(50);

export const state = Yup.string().max(50);

export const postcode = Yup.string().max(5); //TODO Only For Malaysia

export const country = Yup.string().matches(/^[a-zA-Z]{2}$/i);

export const orgName = Yup.string().min(3).max(152);

export const website = Yup.string().matches(
  /((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/
);

export const employeeID = Yup.string()
  .matches(/^[a-zA-Z0-9]+$/i)
  .min(3);

export const registrationNumber = Yup.string()
  .matches(/^[a-z0-9]+$/i)
  .min(3);

export const regulationType = Yup.mixed().oneOf([
  "SOLE_PROPRIETORSHIP",
  "PARTNERSHIP",
  "PRIVATE_LIMITED",
  "PUBLIC_LIMITED",
  "LIMITED_LIABILITY_PARTNERSHIP",
  "FOREIGN_COMPANY",
]);

export const uuidv4Regex = "[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}";

export const validUUID = Yup.string().matches(new RegExp("[A-Za-z]+/" + uuidv4Regex, "i"));

export const validBoolean = Yup.boolean();

export const decimal = Yup.string().matches(/^([0-9]+[.])?[0-9]+$/);

export const allDecimals = Yup.string().matches(/^[-]?([0-9]+[.])?[0-9]+$/);

export const validNumber = Yup.number().integer().min(0);

// FOR ORDER-SETTINGS

export const surcharge = Yup.object().shape(
  {
    fixedAmount: Yup.mixed().when("percentage", {
      is: null || undefined,
      then: decimal.required(),
      otherwise: Yup.lazy((value) => {
        return value ? decimal : Yup.mixed().optional();
      }),
    }),
    percentage: Yup.mixed().when("fixedAmount", {
      is: null || undefined,
      then: percent.required(),
      otherwise: Yup.lazy((value) => {
        return value ? percent : Yup.mixed().optional();
      }),
    }),
    capAmount: Yup.mixed().when("percentage", {
      is: (value) => value,
      then: decimal.required(),
    }),
  },
  [["fixedAmount", "percentage"]]
); // to declare which keys are dependent on one another

export const dateRange = Yup.string().test(
  "compareDate",
  "validFrom must be earlier than validTo",
  (val, context) => {
    const { validFrom } = context.parent;
    return val ? val > validFrom : false;
  }
);

export const timeRange = Yup.string().test(
    "compareTime",
    "startTime must be earlier than endTime",
    (val, context) => {
        const { startTime } = context.parent;
        return val ? val > startTime : false;
    }
)

export const valueRange = Yup.string().test(
    "compareValue",
    "The values from and to are overlapping.",
    (val, context) => {
        const { valueFrom } = context.parent;
        return val ? parseFloat(val) > parseFloat(valueFrom) : false;
    }
)
